mutation UserTemplateDelete($input: UserTemplateDeleteInput!) {
  userTemplateDelete(input: $input) {
    entityDeletes {
      id
      rowTimestamp
    }
  }
}
